import { format, isValid, parse } from 'date-fns';

export interface DateRangeValue {
	startDate: Date | null;
	endDate: Date | null;
}

export interface DateRangeFilterValue {
	startDate: Date;
	endDate: Date;
	utcStartDate: string;
	utcEndDate: string;
	hasTime: boolean;
}

export interface IDateRangePicker {
	onApply: (value: DateRangeFilterValue) => void;
	onClear?: () => void;
	onClose?: () => void;
	loading?: boolean;
	initialStartDate?: Date | null;
	initialEndDate?: Date | null;
}

export interface ISegment {
	year: string;
	month: string;
	day: string;
}

export interface ISegmentedDateInputProps {
	value: Date | null;
	syncSignal: number;
	ariaLabel: string;
	onChange: (date: Date | null) => void;
}

export const toSegments = (date: Date | null): ISegment =>
	date ? { year: format(date, 'yyyy'), month: format(date, 'MM'), day: format(date, 'dd') } : { year: '', month: '', day: '' };

export const buildDate = ({ year, month, day }: ISegment): Date | null => {
	if (year.length !== 4 || month.length !== 2 || day.length !== 2) return null;
	const raw = `${year}-${month}-${day}`;
	const parsed = parse(raw, 'yyyy-MM-dd', new Date());
	return isValid(parsed) && format(parsed, 'yyyy-MM-dd') === raw ? parsed : null;
};

export const onlyDigits = (value: string, max: number): string => value.replace(/\D/g, '').slice(0, max);
